<template>
  <div>
    <div class="input-full">
      <div>
        <div class="card-content padding">
          <div class="form-container">
            <form>
              <DxForm label-location="left" :form-data="formData">
                <DxItem
                  data-field="orderNumber"
                  editor-type="dxTextBox"
                  :editor-options="{
                    disabled: false,
                    width: '100%',
                  }"
                >
                  <DxLabel :visible="false" text="prueba" />
                </DxItem>
              </DxForm>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { DxForm, DxItem, DxLabel } from 'devextreme-vue/form';
import EventBus from '@/services/event-bus';

export default {
  components: {
    DxForm,
    DxItem,
    DxLabel,
  },
  props: {
    store: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      formData: {
        orderNumber: null,
      },
    };
  },
  computed: {},
  watch: {
    formData: {
      handler(FormData) {
        EventBus.$emit('formData4', FormData);
      },
      deep: true,
    },
  },
};
</script>
